module.exports = __webpack_public_path__ + "static/media/asagi-eyes-closed.1b3710a5.png";